import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/promotion-description.module.css';

function PromotionDescription({ tag = 'div', className = null, ...props }: TypographyProps) {
    return (
        <Typography
            tag={tag}
            className={classNames([styles.container, className ?? undefined])}
            {...props}
        />
    );
}

export default PromotionDescription;
